import emptyScenario from './waypoint.empty-state';
import { viewerPermissions } from '../helpers/permissions';

export default function (server) {
  emptyScenario(server, {
    allowedPermissions: viewerPermissions,
  });
}
